var map = {
	"./AIGuidance.js": 1605,
	"./accompany.js": 32844,
	"./activity.js": 47226,
	"./adviser.js": 34539,
	"./app.js": 18895,
	"./ask.js": 18814,
	"./ask2.js": 414,
	"./chronicDisease.js": 52034,
	"./clinic.js": 12170,
	"./examination.js": 40686,
	"./flowers.js": 16114,
	"./guidance.js": 24585,
	"./home.js": 49357,
	"./imgstore.js": 16100,
	"./insurance.js": 69091,
	"./live.js": 80257,
	"./miniProgram.js": 77492,
	"./operation.js": 2655,
	"./overtimeClinic.js": 94977,
	"./physicalExamination.js": 4697,
	"./popup.js": 51752,
	"./privately.js": 5909,
	"./registration.js": 39703,
	"./setPiontHosInfo.js": 69898,
	"./special.js": 77819,
	"./symptom.js": 67359,
	"./train.js": 39707,
	"./transfer.js": 18018,
	"./ucenter.js": 30563,
	"./zipstore.js": 59266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52645;